export default __webpack_public_path__ + "781f75894c7eaa248a14a420b32a940f.png";